<script>
	import { fade } from "svelte/transition"

	const releases = [
		{
			image: "/artwork-backtothecity.jpg",
			links: [
				{icon: "bxl-spotify", url: "https://open.spotify.com/artist/2KvUcfnHVVyXEl1A09mvX3?si=TvHTP7oBSI-M4TaJJWqMBA"},
				{icon: "bxl-apple", url: "https://music.apple.com/se/album/to-the-city/1569735605?i=1569735996&l=en"},
				{icon: "bxl-youtube", url: "https://music.youtube.com/watch?v=O2StYqdW6ek&feature=share"},
			]
		},
		{
			image: "/artwork-wawn.jpeg",
			links: [
				{icon: "bxl-spotify", url: "https://open.spotify.com/album/5VQ97ngIMSzlpcxIUgs4P1"},
				{icon: "bxl-apple", url: "https://music.apple.com/se/album/where-are-we-now-single/1563320388?l=en"},
				{icon: "bxl-youtube", url: "https://music.youtube.com/watch?v=2leATNc0jmA&feature=share"},
			]
		},
		{
			image: "/ltli-artwork.jpg",
			links: [
				{icon: "bxl-spotify", url: "https://open.spotify.com/album/68TfWMLVlui8DXsOPmrBBY"},
				{icon: "bxl-apple", url: "https://music.apple.com/us/album/let-the-light-in-single/1535393984"},
				{icon: "bxl-youtube", url: "https://music.youtube.com/playlist?list=OLAK5uy_kNeXbze4rUdZQ8P1URT-0jRXSh_qHQKyM&feature=share"},
			]
		}
	]
</script>

<div class="container">
	<div class="row mt-3">
		<div class="col text-center">
			<h2>new music coming soon</h2>
			<h1 class="hidden">Mark-Herman</h1>
		</div>
	</div>
	<div class="hidden row justify-content-center pt-5">
		{#each releases as release}
		<div class="col-md-3">
			<img transition:fade src="{release.image}" alt="Let The Light In" width="100%" />
			<div class="mt-3 text-center" style="letter-spacing: 2px;">
				LISTEN ON
			</div>
			<div class="d-flex mt-3 justify-content-center icons">
				{#each release.links as item}
				<div class="ml-3 mr-3 text-center">
					<a href="{item.url}" target="_blank"><i class='bx {item.icon}' ></i></a>
				</div>
				{/each}
			</div>
		</div>
		{/each}
	</div>

	<div class="row" style="margin-top: 150px;">
		<div class="col text-center copyright">
			© 2020-2025 Mark-Herman<br>
			Words and music by Mark-Herman Schellhas
		</div>
	</div>
</div>

<style>
	.hidden {
		display: none;
	}
	.icons a {
		font-size: 3rem;
		color: #eeeeee;
	}

	.copyright {
		font-size: 0.7rem;
		color: #777777;
		padding-bottom: 100px;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>